export const Alerts = {
  confirmWithApps:
    'You have 1 or more applications that will need to be withdrawn before you can deactivate your account. Please confirm you would like to withdraw applications and deactivate your account.',
  unhandled:
    'An unhandled error has occurred. Please try again later or contact BACP.',
  confirmName: 'Please enter name exactly as it appears on your profile.',
  success: 'Your account has been deactivated.',
  hasActiveRegs:
    'You have active registrations. Please contact BACP to de-list these applications before deactivating your account.',
};
